import { Form, DatePicker } from "antd";
// --------------------- Import dayJS ---------------------
import dayjs from "dayjs";
import "dayjs/locale/pt-br"; // Caso queira suportar o formato em português
import customParseFormat from "dayjs/plugin/customParseFormat";
import { ContainerForm, layout } from "../styles";
import { useEffect } from "react";
import { Informacao } from "../Interface/Informacao";
import { validarCampos } from "../utils/validadores";

interface FormMaisInfoProps {
  setFormMaisInfo: (values: Partial<Informacao>) => void;
  formMaisInfo: Partial<Informacao>;
  onValidChange: (isValid: boolean) => void;
}

/**
 * Formulário para verificação se Usuário está procurando ou disponibilizando.
 * Inclui campo de .
 * @returns Componente de formulário Procura Disponibiliza
 */

export default function FormMaisInfo({
  setFormMaisInfo,
  formMaisInfo,
  onValidChange,
}: FormMaisInfoProps) {
  const [form] = Form.useForm();

  dayjs.extend(customParseFormat);

  const formChange = async (_: Partial<any>, allValues: any) => {
    const valores = form.getFieldsValue(["dataIni", "dataFim"]);
    const isValid = validarCampos<Informacao>(valores, ["dataIni", "dataFim"]);
    onValidChange(isValid);
    if (isValid) {
      setFormMaisInfo(allValues);
    }
  };

  useEffect(() => {
    if (formMaisInfo) {
      form.setFieldsValue(formMaisInfo);
    }
  }, [formMaisInfo, form]);

  return (
    <ContainerForm>
      <Form
        form={form}
        name="form-info"
        {...layout}
        autoComplete="off"
        style={{ maxWidth: 600 }}
        onValuesChange={(changedValues, allValues) =>
          formChange(changedValues, allValues)
        }
      >
        <Form.Item
          hasFeedback
          name={["dataIni"]}
          label="Data Inicío "
          className="formItems"
          rules={[{ required: true, message: "O data início é obrigatória" }]}
        >
          <DatePicker placeholder="Data Inicío" format="DD/MM/YYYY" />
        </Form.Item>
        <Form.Item
          hasFeedback
          name={["dataFim"]}
          label="Data Fim "
          className="formItems"
          rules={[{ required: true, message: "O data fim é obrigatória" }]}
        >
          <DatePicker placeholder="Data Fim" format="DD/MM/YYYY" />
        </Form.Item>
      </Form>
    </ContainerForm>
  );
}
